"use client";
import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import FooterFlag from "../../../public/images/Footer-Flags.png";
import NoSsr from "./common/noSsr";
import { matchEmail } from "../utils/helper";
import { getGradientClass } from "~/styles/styles";
import { SOCIAL_ICONS, SOCIAL_LINKS } from "~/content/contact";
import { INCLUSO_ABN } from "~/content/value";
import { SERVICE_LIST } from "~/content/services";
import {
  AboutUs,
  ContactUs,
  Services,
  WhyIncluso,
  Career,
  PrivacyPolicy,
  CommunityEngagementService,
  SupportCoordinationService,
} from "~/content/navLinks";

export const navigation = {
  services: [
    { name: "Concierge Service", href: Services.href },
    // SupportCoordinationService,
    CommunityEngagementService,
    {
      name: SERVICE_LIST.personal.name,
      href: SERVICE_LIST.personal.href,
    },
    {
      name: SERVICE_LIST.accommodation.name,
      href: SERVICE_LIST.accommodation.href,
    },
  ],
  company: [
    { name: `${WhyIncluso.name} Services`, href: WhyIncluso.href },
    { name: AboutUs.name, href: AboutUs.href },
    { name: Career.name, href: Career.href },
    { name: ContactUs.name, href: ContactUs.href },
  ],
  policies: [
    { name: PrivacyPolicy.name, href: PrivacyPolicy.href },
    { name: "Cancellation Policy", href: "" },
    { name: "Terms of Use", href: "" },
  ],
};

const Footer = () => {
  const year = new Date().getFullYear();

  const [email, setEmail] = useState("");
  const [formMessage, setFormMessage] = useState({
    message: "",
    error: false,
  });

  return (
    <footer
      className={`relative isolate z-20 font-sans font-secondary ${getGradientClass("v-l-to-d")}`}
      aria-labelledby="footer-heading"
    >
      <div className="mx-auto max-w-7xl px-8 pb-8 pt-8 sm:pt-10 ml:px-12 lg:pt-12 2xl:px-0">
        <div className="pb-4 xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="grid grid-cols-5 justify-evenly gap-x-8 gap-y-6 md:grid-cols-4 md:gap-8 lg:col-span-2">
            <div className="col-span-3 md:col-auto">
              <h3 className="text-xs font-semibold leading-6 text-gray-300 xs:text-sm">
                Services
              </h3>
              <ul role="list" className="mt-2 space-y-0.5">
                {navigation.services.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      className="text-xs capitalize leading-3 text-gray-300 hover:text-white xs:text-sm"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 md:col-auto">
              <h3 className="text-xs font-semibold leading-6 text-gray-300 xs:text-sm">
                Company
              </h3>
              <ul role="list" className="mt-2 space-y-0.5">
                {navigation.company.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      className="text-xs leading-6 text-gray-300 hover:text-white xs:text-sm"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-3 md:col-auto">
              <h3 className="text-xs font-semibold leading-6 text-gray-300 xs:text-sm">
                Policies
              </h3>
              <ul role="list" className="mt-2 space-y-0.5">
                {navigation.policies.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      className="text-xs leading-3 text-gray-300 hover:text-white xs:text-sm"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 md:col-auto">
              <h3 className="text-xs font-semibold leading-6 text-gray-300 xs:text-sm">
                Follow us on
              </h3>
              <ul role="list" className="mt-2 space-y-0.5">
                <SOCIAL_LINKS />
              </ul>
            </div>
          </div>

          <div className="mt-10 xl:mt-0">
            <h3 className="text-xs font-semibold leading-6 text-gray-300 xs:text-sm">
              Subscribe to our newsletter
            </h3>
            <p className="mt-2 text-xs leading-6 text-gray-300 xs:text-sm">
              The latest news, articles, and resources, from the Incluso team.
            </p>
            <NoSsr>
              <form
                className="mt-5 sm:mt-3 sm:max-w-md"
                hs-do-not-collect="true"
              >
                {/* disable default submit */}
                <input
                  type="submit"
                  disabled
                  className="hidden"
                  aria-hidden="true"
                />
                <div className="sm:flex">
                  <label htmlFor="email-address" className="sr-only">
                    Email address
                  </label>
                  <input
                    type="email"
                    name="email-address"
                    id="email-address"
                    autoComplete="email"
                    required
                    className="w-full min-w-0 appearance-none rounded-md border-0 bg-white px-3 py-1.5 text-xs text-gradient-blue2 shadow-sm ring-1 ring-inset ring-white/10 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:w-64 sm:text-sm sm:leading-6 xl:w-full"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => {
                      // only (re)validate email on change when we already had an error
                      // this also resets the message if the user already sent off the subscription
                      if (formMessage && matchEmail(e.target.value)) {
                        setFormMessage({ message: "", error: false });
                      }
                      setEmail(e.target.value);
                    }}
                  />
                  <div className="mt-4 self-center xs:text-sm sm:ml-4 sm:mt-0 sm:flex-shrink-0">
                    <button
                      type="submit"
                      className="flex h-[90%] select-none items-center justify-center rounded-sm bg-orange px-5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-opacity-85 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white md:text-sm"
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
                <div className="mt-2 leading-none">
                  <span
                    className={`text-resp-sm ${formMessage.error ? "text-red" : "text-gray-300"}`}
                  >
                    {formMessage.message}
                  </span>
                </div>
                <div className="mt-3 leading-none">
                  <span className="text-[0.6rem] text-gray-300 xs:text-xs">
                    {`This site is protected by reCAPTCHA and the Google`}
                    <Link
                      className="mx-1 transition hover:text-white"
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </Link>
                    {`and`}
                    <Link
                      className="mx-1 transition hover:text-white"
                      href="https://policies.google.com/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Service
                    </Link>
                    {`apply.`}
                  </span>
                </div>
              </form>
            </NoSsr>
          </div>
        </div>
        <div
          className="flex flex-col flex-wrap items-center justify-evenly gap-x-2 gap-y-4 px-4 pb-4 pt-6 max:container xs:flex-nowrap sm:flex-row sm:px-8 sm:pt-8 max:m-auto"
          id="acknowledgement-of-country"
        >
          <div className="flex gap-x-6 xs:gap-x-2">
            <div className="border-2 border-white/10">
              <Image src={FooterFlag} alt="flags" height={33} />
            </div>
          </div>
          <p className="text-center text-[0.5rem] text-gray-300 xs:text-xs md:order-1 md:mt-0 max:text-sm">
            We acknowledge the Traditional Custodians of the land on which we
            work, live and operate. We pay our respects to Elders past, present
            and emerging.
          </p>
        </div>

        <div className="mt-8 hidden border-t border-white pt-2 sm:block md:items-center md:justify-between lg:mt-8"></div>

        <div className="mt-2 sm:flex sm:items-center sm:justify-between">
          <div className="mb-2 flex justify-center gap-1 sm:order-2 md:mb-0">
            <SOCIAL_ICONS />
          </div>
          <p className="mt-xs text-center text-[0.6rem] leading-5 text-gray-300 xs:text-xs sm:text-left md:order-1 md:mt-0 max:text-sm">
            &copy; {year} Incluso Services Pty Ltd.&nbsp; All rights reserved.{" "}
            <span>&nbsp;ABN: {INCLUSO_ABN}</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
